module.exports = __webpack_public_path__ + "img/dku.00119.31670def.png";